import { objectCompare } from '@src/slide/infrastructure/module/independent/assert/compare';

export const MULTI = 'multi';

/**
 * or 逻辑
 * raw === compare return compare
 * raw !== compare return 'multi'
 * @param {*} raw
 * @param {*} compare
 */
function deepOrMerge(raw, compare) {
    return objectCompare(raw, compare) ? raw : MULTI;
}

/**
 * 找到最小值
 * raw === compare return compare
 * raw !== compare return `${min(raw, compare)}+`
 * @param {*} raw
 * @param {*} compare
 */
function minMerge(raw, compare): string {
    if (raw === compare) return compare;
    const minFont = `${Math.min(Number(parseFloat(raw).toFixed(1)), Number(parseFloat(compare).toFixed(1)))}`;
    if (/\.5/.test(minFont)) return `${minFont}+`;
    return `${parseInt(minFont, 10)}+`;
}

function levelMerge(raw, compare) {
    if (Array.isArray(raw)) {
        return raw.concat([compare]);
    }
    return [raw].concat([compare]);
}

function effectMerge(raw, compare) {
    if (raw === undefined && compare === undefined) {
        // 都没有设置效果，则返回undefined
        return undefined;
    } if (raw && compare) {
        // 都有设置效果，则需细化分析各种效果是否一致
        const rawKeys = Object.keys(raw);
        const compareKeys = Object.keys(compare);
        const combObj = rawKeys.concat(compareKeys)
            .reduce((pre, cur) => ({ ...pre, [cur]: null }), {});
        Object.keys(combObj).forEach((p) => {
            combObj[p] = objectCompare(raw[p], compare[p]) ? raw[p] : MULTI;
        });
        return combObj;
    }
    // 一个设置了一个没设置，则返回所有设置的效果属性为MULTI
    const comb = raw || compare;
    return Object.keys(comb)
        .filter(e => !!comb[e])
        .reduce((pre, cur) => ({ ...pre, [cur]: MULTI }), {});
}

/**
* styleMerge的factory，对不同的style返回不同的merge方法
* @param {*} style style名称
*/
function styleMergeFactory(style: string) {
    switch (style) {
        case 'fontSize':
            return minMerge;
        case 'level':
            return levelMerge;
        case 'effect':
            return effectMerge;
        default:
            return deepOrMerge;
    }
}

/**
* 对单style对象进行merge
* @param {object} raw { key1: val1, key2: val2, key3: val3 }
* @param {object} curr { key1: val1, key2: val2 }
*/
export function styleMerge(raw, curr) {
    const keys = [
        ...Object.keys(raw),
        ...Object.keys(curr),
    ];

    const p: { [key: string]: any } = {};

    keys.forEach((key) => {
        // 对不同key，merge逻辑是不一样的
        p[key] = styleMergeFactory(key)(raw[key], curr[key]);
    });

    return p;
}

/**
* 对textrun的styles进行merge
* @param {array} styles styles
*/
export default function stylesMerge(styles) {
    if (!styles || styles.length < 1) return {};
    const s = styles.reduce((prev, curr) => styleMerge(prev, curr)); // 不能给初始值，如果给了的话会造成styleMerge全部变成multi

    return s;
}
